var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 19.25C10.622 19.25 11.6667 18.4665 11.6667 17.5C11.6667 16.5335 10.622 15.75 9.33333 15.75C8.04467 15.75 7 16.5335 7 17.5C7 18.4665 8.04467 19.25 9.33333 19.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8176 18.3775C20.6086 18.3712 17.161 19.0871 13.4167 21.5833C11.5699 22.8144 9.80577 23.6396 8.293 24.1778M24.8176 18.3775C25.3651 17.0257 25.6667 15.548 25.6667 13.9999C25.6667 13.7245 25.6571 13.4514 25.6384 13.1807M24.8176 18.3775C23.0863 22.6517 18.8953 25.6666 14 25.6666C11.927 25.6666 9.98016 25.1258 8.293 24.1778M8.293 24.1778C4.7363 22.1792 2.33337 18.3701 2.33337 13.9999C2.33337 12.8231 2.5076 11.687 2.83169 10.616M25.6384 13.1807C19.72 16.6221 16.7241 15.2973 10.5 11.6666C7.65652 10.0079 4.99349 9.98352 2.83169 10.616M25.6384 13.1807C25.565 12.1216 25.3501 11.1014 25.0127 10.1389M2.83169 10.616C3.46763 8.51433 4.68056 6.6633 6.28618 5.24715M25.0127 10.1389C23.419 5.59304 19.0902 2.33325 14 2.33325C11.0427 2.33325 8.34243 3.43357 6.28618 5.24715M25.0127 10.1389C20.2753 10.1389 20.4167 5.57061 14 6.99992C9.80004 7.93547 7.30192 6.02678 6.28618 5.24715",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactIcon);
export default __webpack_public_path__ + "static/media/ImpactIcon.db5ad00c2151b3f606cb656b85995cb5.svg";
export { ForwardRef as ReactComponent };